import React from "react";
import {connect} from "react-redux";
import {FieldArray, formValueSelector, reduxForm} from "redux-form";
import {ff, form, Icon, Loader, utils} from "@mc/mc-legacy";
import * as findCombinationsActions from "../../actions/findCombinationsActions";
import * as signerActions from "../../actions/signerActions";
import {Button} from "reactstrap";
import {Col, Row} from "@mc/ui-v3";
import "./SignConfigurationForm.scss";

const {Form, FormBody, FormActions} = form;

const validate = (formData) => {
    const errors = {};

    if (!formData.name) {
        errors.name = "Musí být vyplněn název konfigurace";
    }
    if (!formData.code) {
        errors.code = "Musí být vyplněn kód konfigurace";
    }
    if (!formData.typesCombination) {
        errors.typesCombination = "Musí být vyplněna kombinace prostředků";
    }

    // Pokud je součástí kombinace uživatelský podpis, validuji podepisující
    if (formData.typesCombination && formData.typesCombination.signatureLevel !== 'NONE') {
        if (!formData.signers || formData.signers.length === 0) {
            errors.signers = "Musí být vyplněn alespoň jeden podepisující";
        } else {
            formData.signers.forEach((signer, index) => {
                if (!signer.pracovnik) {
                    if (!errors.signers) {
                        errors.signers = [];
                    }
                    errors.signers[index] = {
                        pracovnik: "Musí být vybrán podepisující",
                    }
                }
            });

            if (!errors.signers || errors.signers === 0) {
                const ids = formData.signers.map(p => p?.pracovnik?.id);

                let idsDeduplicate = [];
                let id = null;
                ids.forEach(function (item, index) {
                    if (idsDeduplicate.indexOf(item) < 0) {
                        idsDeduplicate.push(item);
                    } else {
                        id = index
                    }
                });

                if (idsDeduplicate.length !== formData.signers.length) {
                    if (!errors.signers) {
                        errors.signers = [];
                    }
                    errors.signers[id] = {
                        pracovnik: "Každý podepisující může být vybrán maximálně jednou",
                    };
                }
            }
        }
    } else if (formData.typesCombination && formData.typesCombination.signatureLevel === 'NONE') {
        formData.signers.forEach((signer, index) => {
            if (signer.pracovnik) {
                if (!errors.signers) {
                    errors.signers = [];
                }
                errors.signers[index] = {
                    pracovnik: "Nesmí být vybrán podepisující",
                }
            }
        });
    }

    return errors;
};

class SignConfigurationForm extends React.Component {
    static formName = "SignConfigurationForm";

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.fetchData(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.fetchData(nextProps);
    }

    fetchData = (props) => {
        props.dispatch(findCombinationsActions.fetchCombinationsIfNeeded());
        props.dispatch(signerActions.fetchSignersIfNeeded());
    };

    renderPodepisujici = ({fields}) => {
        const {onClose, submitting, handleSubmit, onSubmit, KombinaceList, SignerList} = this.props;
        const podepisujiciItems = [];
        SignerList.rows &&
        SignerList.rows.forEach((item) => {
            podepisujiciItems.push({
                ...item.pracovnik,
                // name: `${item.pracovnik.uplneJmeno} ${item.pracovnik.organizacniJednotka ? `(${item.pracovnik.organizacniJednotka.kod})` : ""}`,
                // title: item.pracovnik.organizacniJednotka.nazev,
            });
        });
        return (
            <div>
                {fields.map((field, index) => (
                    <Row noGutters key={index}>
                        <Col>
                            <ff.Autocomplete
                                name={field + ".pracovnik"}
                                items={podepisujiciItems}
                                useIdAsValue={false}
                                label="Podepisující"
                                getItemName={(item) => {
                                    return item ? item.uplneJmeno + " " + (item.organizacniJednotka ? `(${item.organizacniJednotka.kod})` : "") : ""
                                }}
                                renderItemContent={(item, name) => {
                                    if (name && name.length > 0) {
                                        return (
                                            <span title={item.title ? item.title : ""} className="item-text">
                                {item.uplneJmeno} {item.organizacniJednotka ? `(${item.organizacniJednotka.kod})` : ""}
                              </span>
                                        );
                                    } else {
                                        return <span className="item-text">&nbsp;</span>;
                                    }
                                }}
                            />
                            <ff.String label="" placeholder={'Popis k podepisujícímu'}
                                       name={field + ".signerDescription"}
                                       disabled={submitting}/>
                        </Col>
                        {index != 0 && (
                            <Col className="d-flex justify-content-center" xs="auto">
                                {" "}
                                <Button
                                    className="d-flex px-1 align-self-center mt-1 btn-transparent "
                                    title="Odebrat podepisujícího"
                                    onClick={() => {
                                        fields.remove(index);
                                        // change(SignConfigurationForm.formName, "pracovniciID", this.props.pracovniciID.splice(index));
                                    }}
                                >
                                    <Icon size="2x" icon={"trash-o"}/>
                                </Button>
                            </Col>
                        )}
                        {index + 1 == fields.length && (
                            <Col className="d-flex justify-content-center" xs="auto">
                                <Button
                                    className="d-flex pr-1 align-self-center mt-2 btn-transparent"
                                    title="Přidat podepisujícího"
                                    onClick={() => {
                                        fields.push({pracovnik: null, signerDescription: null})
                                    }}>
                                    <Icon size="2x" icon={"plus-square-o"}/>
                                </Button>
                            </Col>
                        )}
                    </Row>
                ))}
            </div>
        )
    }

    render() {
        const {onClose, submitting, handleSubmit, KombinaceList} = this.props;
        const items = [];
        KombinaceList.filteredRows &&
        KombinaceList.filteredRows.forEach((item) => {
            items.push(item);
        });
        return (
            <Form onSubmit={handleSubmit}>
                <FormBody>
                    <ff.String required label="Název konfigurace" name="name" disabled={submitting}/>
                    <ff.String required label="Kód konfigurace" name="code" disabled={submitting}/>
                    <FieldArray name="signers" component={this.renderPodepisujici}/>
                    {items.length > 0 ? (
                        <ff.Autocomplete
                            getItemName={(item) => (item ? item.name : "")}
                            getItemId={(item) => (item ? item.id : "")}
                            name="typesCombination" label="Kombinace" required items={items} disabled={submitting}/>
                    ) : (
                        <Loader/>
                    )}
                </FormBody>
                <FormActions onClose={onClose} storeButton cancelButton disabled={submitting}/>
            </Form>
        );
    }
}

function mapStateToProps(state) {
    const selector = formValueSelector(SignConfigurationForm.formName);
    return {
        KombinaceList: utils.storeFromArea(state, findCombinationsActions.KOMBINACE_LIST),
        SignerList: utils.storeFromArea(state, signerActions.SIGNER_LIST),
        signers: selector(state, "signers"),
    };
}

const reduxFormObj = reduxForm({
    form: SignConfigurationForm.formName,
    validate: validate,
})(SignConfigurationForm);
export default connect(mapStateToProps)(reduxFormObj);
